import { useTranslation } from "react-i18next";

import AddIcon from "@mui/icons-material/Add";
import {
  IconButton,
  List,
  ListItem,
  ListProps,
  ListSubheader,
  Tooltip,
  Typography,
  styled,
} from "@mui/material";

import { NewPatientCard, PatientCard } from "./PatientCard";
import { Patient } from "../models/patient";
import { useAppContext } from "../context/AppContext";
import { usePatients } from "../queries/patients-query";

const StyledList = styled(List)(() => ({
  scrollbarWidth: "thin",
}));

const StyledListSubheader = styled(ListSubheader)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderBottom: `0.75px solid ${theme.palette.divider}`,
}));

export const PatientsList: React.FC<ListProps> = ({ ...listProps }) => {
  const { t } = useTranslation();

  const { dataConfig, togglePatientDialog } = useAppContext();

  const { data: patients } = usePatients();

  return (
    <StyledList
      subheader={
        <StyledListSubheader
          disableGutters
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 0.5,
          }}
        >
          <Typography variant="overline" flexGrow={1}>
            {t("patients.count", { count: patients?.length || 0 })}
          </Typography>
          <Tooltip title={t("patient.create-cta")}>
            <IconButton
              color="primary"
              onClick={() => togglePatientDialog()}
              size="small"
            >
              <AddIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </StyledListSubheader>
      }
      {...listProps}
    >
      {patients?.map((patient: Patient) => (
        <ListItem disablePadding key={patient.id} sx={{ mt: 2 }}>
          <PatientCard
            patient={patient}
            selected={patient.id === dataConfig.patientId}
            sx={{ flexGrow: 1 }}
          />
        </ListItem>
      ))}
      <ListItem disablePadding sx={{ mt: 2 }}>
        <NewPatientCard
          onClick={() => togglePatientDialog()}
          sx={{ flexGrow: 1 }}
        />
      </ListItem>
    </StyledList>
  );
};
